export const MEMBERSHIP_TYPES_CONST = {
    TYPE_PLAN: 'plan',
    TYPE_SESSION: 'session',
    TYPE_ITEM: 'item',
    TYPE_SERVICE: 'service',
    SELECT_TYPE_MEMBERSHIPS: 'memberships',
    SELECT_TYPE_ITEMS: 'items',
};

